import '../base-modal.css';
import './info-modal.css';

import React from 'react';
import packageInfo from '../../../package.json';
import { openExternalLink } from '../../utils/navigation';
import { useTranslation } from 'react-i18next';

interface ModalProps {
    onClose: (deleted: boolean) => void;
}

const InfoModal: React.FC<ModalProps> = ({ onClose }) => {
    const { t } = useTranslation();
    return (
        <div className="modal-backdrop">
            <div className="modal-box">
                <h3 className="input-modal-title mb-4">{t("modals.info_modal.questions_or_issues")}</h3>
                <p>Version: v{packageInfo.version}</p>
                <p>Bei Fragen oder Probleme wende dich bitte per E-Mail an <a href="mailto:support@getmanagd.com">support@getmanagd.com</a>.</p>
                <div className="text-end mt-4">
                    <button className="btn btn-outline-secondary me-2 impressum-btn" onClick={() => openExternalLink('https://www.danielgarofoli.com/impressum')}>{t("modals.info_modal.imprint")}</button>
                    <button className="btn btn-dark close-btn" onClick={() => onClose(false)}>{t("modals.info_modal.close")}</button>
                </div>
            </div>
        </div>
    );
};

export default InfoModal;
